<template>
  <article>
    <section class="xbed-sub-title">
      <span>智能硬件管理</span>
    </section>
    <section class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>前台自助机管理</BreadcrumbItem>
        <BreadcrumbItem>自助机详情</BreadcrumbItem>
      </Breadcrumb>
    </section>
    <section>
      <Card>
        <p slot="title">基本信息</p>
        <div>
          <Row class="row">
            <Button @click="editInfoBtn">编辑</Button>
          </Row>
          <Row class="row">
            <Col span="2">
              <span>自助机id：</span>
            </Col>
            <Col span="4">
              <span>{{info.id}}</span>
            </Col>
          </Row>
          <Row class="row">
            <Col span="2">
              <span>型号：</span>
            </Col>
            <Col span="4">
              <span>{{info.machineModel}}</span>
            </Col>
          </Row>
          <Row class="row">
            <Col span="2">
              <span>机器码：</span>
            </Col>
            <Col span="4">
              <span>{{info.machineCode}}</span>
            </Col>
          </Row>
          <Row class="row">
            <Col span="2">
              <span>安装省市区：</span>
            </Col>
            <Col span="12">
              <span>{{`${info.province || ''} ${info.city || ''} ${info.district || ''} ${info.installStreetAddress}`}}</span>
            </Col>
          </Row>
          <Row class="row">
            <Col span="2">
              <span>高德坐标</span>
            </Col>
            <Col span="4">
              <span>经度：</span>
              <span>{{info.latitudeLongitude ? info.latitudeLongitude.split(',')[0] : ''}}</span>
            </Col>
            <Col span="4">
              <span>纬度：</span>
              <span>{{info.latitudeLongitude ? info.latitudeLongitude.split(',')[1] : ''}}</span>
            </Col>
          </Row>
          <Row class="row">
            <Col span="2">
              <span>是否启用：</span>
            </Col>
            <Col span="4">
              <span>{{info.enable ? '启用' : '停用'}}</span>
            </Col>
          </Row>
          <Row class="row">
            <Col span="2">
              <span>机器状态：</span>
            </Col>
            <Col span="4">
              <span>{{info.machineStatus ? '正常' : '异常'}}</span>
            </Col>
          </Row>
        </div>
      </Card>
      <br>
      <Card>
        <p slot="title">绑定门店</p>
        <div>
          <Row class="row">
            <Button @click="addBindEvent">新增绑定</Button>
          </Row>
          <Row class="row">
            <Table :columns="bindListCol" :data="bindedRoomList"></Table>
          </Row>
        </div>
      </Card>
    </section>
    <Modal v-model="editModal.display" :loading="true" title="编辑基本信息" @on-ok='editModalBtn' ref="editModal">
      <Form :model="editModal.data" :rules="editModal.rules" ref="editForm">
        <FormItem label="省份" :label-width="75" prop="provinceCode">
          <Select v-model="editModal.data.provinceCode" @on-change="queryCityList">
            <Option v-for="item in provinceList" :key="item.id" :value="item.id">{{item.custName}}</Option>
          </Select>
        </FormItem>
        <FormItem label="市" :label-width="75" prop="cityCode">
          <Select v-model="editModal.data.cityCode" @on-change="queryCountyList">
            <Option v-for="item in citiesList" :key="item.id" :value="item.id">{{item.custName}}</Option>
          </Select>
        </FormItem>
        <FormItem label="区" :label-width="75" prop="districtCode">
          <Select v-model="editModal.data.districtCode">
            <Option v-for="item in countiesList" :key="item.id" :value="item.id">{{item.custName}}</Option>
          </Select>
        </FormItem>
        <FormItem label="详细地址" :label-width="75" prop="street">
          <Input v-model="editModal.data.street" :maxlength="100"></Input>
        </FormItem>
        <FormItem label="经纬度" :label-width="75" prop="latitudeLongitude">
          <Input v-model="editModal.data.latitudeLongitude">
            <Button slot="append" v-model="editModal.data.latitudeLongitude" @click="openIbs">获取高德坐标</Button>
          </Input>
        </FormItem>
        <FormItem label="启用状态" :label-width="75" prop="enable">
          <Select v-model="editModal.data.enable">
            <Option :value="0">否</Option>
            <Option :value="1">是</Option>
          </Select>
        </FormItem>
      </Form>
    </Modal>
    <Modal v-model="addModal.display" title="新增绑定门店" width="800" @on-ok="bindingRoomEvent">
      <Form inline>
        <FormItem label="门店名称/ID" :label-width="100">
          <Input v-model="unbindRoomData.search.chain"></Input>
        </FormItem>
        <FormItem label=" " :label-width="60">
          <Button type="primary" @click="()=>{this.unbindedRoom(this.info.machineCode)}">查询</Button>
        </FormItem>
      </Form>
      <Table size="small" :columns="unbindRoomColums" :data="unbindRoomList" @on-selection-change="changeRoomSelect"></Table>
      <div style="margin: 10px;overflow: hidden">
        <Page size="small" show-sizer :total="unbindRoomData.count" :current="unbindRoomData.search.page" :page-size="unbindRoomData.search.pageSize"  @on-page-size-change="changePageSize" @on-change="changePage" transfer></Page>
      </div>
    </Modal>
  </article>
</template>

<script>
import Utils from "../../../utils";
import API from "../../../api";
export default {
  async created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
    this.machineId = Utils.getUrlParameterByName('id');
  },
  async mounted() {
    this.$Notice.config({
      top: 200
    });
    await this.queryMachineInfoById();
    this.bindedRoom();
    this.queryProvinceList();
  },
  data() {
    return {
      info: {},
      editModal: {
        display: false,
        data: {
          city: '',
          cityCode: '7042',
          district: '',
          districtCode: '36',
          enable: 0,
          latitudeLongitude: '',
          machineCode: '',
          province: '',
          provinceCode: '1',
          street: '',
        },
        rules: {
          provinceCode: [
            {required: true, type: 'number', message: '请选择省份', trigger: 'change' },
          ],
          cityCode: [
            {required: true, type: 'number', message: '清选择城市', trigger: 'change' },
          ],
          districtCode: [
            {required: true, type: 'number', message: '清选择区域', trigger: 'change' },
          ],
          street: [
            {required: true, message: '请填写详细地址', trigger: 'blur' },
          ],
          latitudeLongitude: [
            {required: true, message: '请填经纬度', trigger: 'blur' },
          ],
          enable: [
            {required: true, type: 'number', message: '请选择', trigger: 'change' },
          ],
        }
      },
      addModal: {
        display: false
      },
      bindListCol: [
        {
          title: '门店ID',
          width: 150,
          align: 'center',
          key: 'chainId'
        },
        {
          title: '门店名称',
          width: 200,
          align: 'center',
          key: 'chainName'
        },
        {
          title: '类型',
          width: 150,
          align: 'center',
          render: (h,param) => {
            return h('span',['分散','聚集'][param.row.chainType])
          }
        },
        {
          title: '省市区',
          width: 200,
          align: 'center',
          key: 'provinceCityDistrict'
        },
        {
          title: '街道地址',
          width: 300,
          align: 'center',
          key: 'address'
        },
        {
          title: '操作',
          width: 150,
          align: 'center',
          render: (h,param)=>{
            return h('div', [
              h('i-button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '解绑自助机',
                      content: '<p>解绑后门店需在xbed客户端办理入住</p><p>不能在自助机上入住和交押金</p><p>确定解绑？</p>',
                      onOk: () => {
                        this.unbindRoom(param.row.chainId)
                      },
                    });
                  }
                }
              }, '解绑')
            ])
          }
        },
      ],
      bindedRoomList: [],
      unbindRoomData: {
        search: {
          page: 1,
          pageSize: 10,
          chain: ''
        },
        count: 0
      },
      unbindRoomColums: [
        {
          type: 'selection',
          width: 65,
          align: 'center'
        },
        {
          title: '门店ID',
          width: 100,
          align: 'center',
          key: 'chainId'
        },
        {
          title: '门店名称',
          width: 150,
          align: 'center',
          key: 'chainName'
        },
        {
          title: '类型',
          width: 100,
          align: 'center',
          render: (h, param) => {
            return h('span', ['分散','聚集'][param.row.chainType])
          }
        },
        {
          title: '省市区',
          width: 150,
          align: 'center',
          key: 'provinceCityDistrict'
        },
        {
          title: '街道地址',
          width: 200,
          align: 'center',
          key: 'address'
        }
      ],
      unbindRoomList: [],
      selectRoom: [],
      provinceList: [],
      citiesList: [],
      countiesList: []
    }
  },
  methods: {
    editInfoBtn() {
      for(let key in this.editModal.data){
        if(this.info[key]!=='' || this.info[key]!==null){
          this.editModal.data[key] = this.info[key]
        }
      }
      this.editModal.data.provinceCode = Number(this.editModal.data.provinceCode);
      this.editModal.data.cityCode = Number(this.editModal.data.cityCode);
      this.editModal.data.districtCode = Number(this.editModal.data.districtCode);
      this.editModal.data.street = this.info.installStreetAddress;
      console.info(this.editModal.data);
      this.editModal.display = true;
    },
    addBindEvent() {
      if(this.info.installStreetAddress && this.info.latitudeLongitude){
        this.addModal.display = true;
        this.unbindedRoom(this.info.machineCode);
      }else{
        this.$Notice.error({
          title: '请完善机器地址、经纬度'
        })
      }
    },
    editModalBtn() {
      this.$refs.editModal.buttonLoading = false;
      this.$refs.editForm.validate((valid) => {
        if(valid) {
          this.editModal.display = false;
          this.editModal.data.province = this.provinceList.filter((item)=>{
            return item.id == this.editModal.data.provinceCode
          })[0].custName;
          this.editModal.data.city = this.citiesList.filter((item)=>{
            return item.id == this.editModal.data.cityCode
          })[0].custName;
          this.editModal.data.district = this.countiesList.filter((item)=>{
            return item.id == this.editModal.data.districtCode
          })[0].custName;
          this.editMachineInfo();
        }
      })
    },
    changeRoomSelect(list) {
      this.selectRoom = list;
    },
    bindingRoomEvent() {
      let ids = this.selectRoom.map((item)=>item.chainId).join();
      this.bindingRoom(ids)
    },
    async queryMachineInfoById() {
      const resp = (await API.omsAPI[this.env].deviceModule.queryMachineInfoById(this.machineId,this.token)).data;
      if(resp.retCode){
        this.$Notice.error({
          title: '获取信息失败',
          desc: '请刷新页面或重新获取'
        })
        return
      }
      this.info = resp;
    },
    async editMachineInfo() {
      let param = Object.assign({}, this.editModal.data);
      param.userId = this.username;
      const resp = (await API.omsAPI[this.env].deviceModule.editMachineInfo(
        param,
        this.token
      )).data;
      if(resp.retCode){
        this.$Notice.error({
          title: '编辑失败',
          desc: resp.msg
        })
        return
      }
      this.$Notice.success({
        title: '编辑成功'
      })
      this.queryMachineInfoById();
    },
    changePageSize(pageSize){
      this.unbindRoomData.search.page = 1
      this.unbindRoomData.search.pageSize = pageSize
      this.unbindedRoom(this.info.machineCode)
    },
    changePage(page){
      
      this.unbindRoomData.search.page = page
      this.unbindedRoom(this.info.machineCode)
    },

    async unbindedRoom(machineCode) {
      const resp = (await API.omsAPI[this.env].deviceModule.unbindedRoom(
        machineCode,
        this.unbindRoomData.search.chain,
        this.unbindRoomData.search.page,
        this.unbindRoomData.search.pageSize,
        this.token
      )).data;
      if(resp.retCode){
        this.$Notice.error({
          title: '获取未绑定门店失败',
          desc: resp.msg
        })
        return 
      }
      this.unbindRoomList = resp.list;
      this.unbindRoomData.count = resp.total;
    },
    async bindedRoom() {
      const resp = (await API.omsAPI[this.env].deviceModule.bindedRoom(
        this.info.machineCode,
        this.token
      )).data;
      if(resp.retCode) {
        this.$Notice.error({
          title: '获取绑定门店失败',
          desc: resp.msg
        })
        return
      }
      this.bindedRoomList = resp;
    },
    async bindingRoom(ids) {
      const resp = (await API.omsAPI[this.env].deviceModule.bindingRoom(
        ids,
        this.info.machineCode,
        this.token
      )).data;
      if(resp.retCode){
        this.$Notice.error({
          title: '绑定失败',
          desc: resp.msg
        })
        return
      }
      this.$Notice.success({
        title: '绑定成功'
      });
      this.bindedRoom();
    },
    async unbindRoom(chainId) {
      const resp = (await API.omsAPI[this.env].deviceModule.unbindRoom(
        chainId,
        this.info.machineCode,
        this.token
      )).data;
      if(resp.retCode){
        this.$Notice.error({
          title: '解绑失败',
          desc: resp.msg
        })
        return 
      }
      this.$Notice.success({
        title: '解绑成功'
      })
      this.bindedRoom();
    },
    async queryProvinceList() {
      this.provinceList = (await this.getDistrictSelective()).province;
    },
    async queryCityList(parentId) {
      if(!parentId) return;
      this.citiesList = (await this.getDistrictSelective(parentId)).city;
    },
    async queryCountyList(parentId) {
      if(!parentId) return;
      this.countiesList = (await this.getDistrictSelective(parentId)).county;
    },
    async getDistrictSelective(parentId) {
      let resp = (await API.omsAPI[this.env].deviceModule.getDistrictSelective(parentId)).data;
      return resp;
    },
    openIbs() {
      window.open('https://lbs.amap.com/console/show/picker')
    }
  }
}
</script>

<style <style lang="scss" scoped>
.row{
  margin-bottom: 15px
}
</style>



// WEBPACK FOOTER //
// src/pages/smart-device/self-service-machine/detail.vue